<template>
  <div class="upsert-form">
    <div class="input-group">
      <picker
        :api="$api.organization($route.params.orgId).gasTypes"
        v-model="formData.gasTypeId"
        value-key="id"
        placeholder="Select gas type" />

      <dg-input type="text" v-model="formData.name" placeholder="Price name"/>
      <dg-input type="text" v-model="formData.price" placeholder="Price/L"/>

      <picker
        :apiData="stations"
        v-model="formData.stationIds"
        value-key="id"
        multiple
        collapse-tags
        :disabled="editing"
        hidePlaceholder
        placeholder="Select station(s)" />

      <el-select
        v-model="assigneeKeys"
        multiple
        collapse-tags
        :disabled="editing"
        placeholder="Select user(s) or group(s)"
        class="assignee-select">
        <el-option-group v-if="groupOptions.length > 0" label="Groups">
          <el-option
            v-for="g in groupOptions"
            :key="g.id"
            :label="g.name"
            :value="g.id" />
        </el-option-group>
        <el-option-group v-if="userOptions.length > 0" label="Users">
          <el-option
            v-for="u in userOptions"
            :key="u.id"
            :label="u.name"
            :value="u.id" />
        </el-option-group>
      </el-select>

      <el-button type="primary" icon="el-icon-upload" @click="handleClick">Save</el-button>
    </div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

const USER_PREFIX = 'user:'
const GROUP_PREFIX = 'group:'

export default {
  name: 'PricesUpsertForm',
  components: { Picker },
  props: {
    userId: {
      type: String,
      required: false
    },
    stationId: {
      type: String,
      required: false
    },
    price: {
      type: Object,
      required: false
    },
    users: {
      type: Array,
      required: true
    },
    stations: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      required: false,
      default: () => []
    },
    editing: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      loading: true,
      assigneeKeys: [],
      formData: {
        name: '',
        price: null,
        organizationId: this.$route.params.orgId,
        gasTypeId: null,
        stationIds: []
      }
    }
  },
  computed: {
    userOptions () {
      return (this.users || []).map(u => ({
        id: USER_PREFIX + u.id,
        name: u.name
      }))
    },
    groupOptions () {
      return (this.groups || []).map(g => ({
        id: GROUP_PREFIX + g.id,
        name: g.name
      }))
    },
    splitAssignees () {
      const userIds = []
      const groupIds = []
      this.assigneeKeys.forEach(key => {
        if (key.indexOf(USER_PREFIX) === 0) userIds.push(key.slice(USER_PREFIX.length))
        else if (key.indexOf(GROUP_PREFIX) === 0) groupIds.push(key.slice(GROUP_PREFIX.length))
      })
      return { userIds, groupIds }
    }
  },
  methods: {
    handleClick () {
      if (this.editing) {
        this.update()
      } else {
        this.add()
      }
    },
    buildPayload () {
      const { userIds, groupIds } = this.splitAssignees
      return { ...this.formData, userIds, groupIds }
    },
    async add () {
      const payload = this.buildPayload()
      const response = await this.$http.post(this.$api.organization(this.formData.organizationId).gasPrice(null).create, payload)
      this.$message.success('Price(s) successfully created')
      this.$emit('created', response.data)
    },
    async update () {
      const payload = this.buildPayload()
      const response = await this.$http.put(this.$api.organization(this.formData.organizationId).gasPrice(this.price.id).update, payload)
      this.$emit('updated', response.data)
      this.$message.success('Price updated successfully')
    }
  },
  created () {
    if (this.price) {
      this.formData.name = this.price.name
      this.formData.price = this.price.price
      this.formData.stationIds = this.price.stationIds
      this.formData.gasTypeId = this.price.gasTypeId
      const initialUserIds = this.price.userIds || []
      const initialGroupIds = this.price.groupIds || []
      this.assigneeKeys = [
        ...initialUserIds.map(id => USER_PREFIX + id),
        ...initialGroupIds.map(id => GROUP_PREFIX + id)
      ]
    }

    if (this.userId) {
      this.assigneeKeys = [USER_PREFIX + this.userId]
    }

    if (this.stationId) {
      this.formData.stationIds = [this.stationId]
    }
  }
}
</script>

<style lang="scss" scoped>
  .suffix {
    height: 40px;
    line-height: 40px;
  }

  .assignee-select {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Pricing/UpsertForm.vue